const analyticsChart = {
  series: [
    {
      data: [],
    },
  ],
  chartOptions: {
    chart: {
      id: "mychart",
      height: 350,
      width: "100%",
      background: "#fff",
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    colors: ["#E33065", "#57697B"],
    plotOptions: {
      bar: {
        columnWidth: "40%",
        borderRadius: 2,
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          fontSize: "13px",
        },
        hideOverlappingLabels: true,
      },
      // title: {
      //   text: "2023",
      //   rotate: 360,
      //   offsetY: -70,
      //   offsetX: 480,
      // },
      axisBorder: {
        show: true,
        color: "#E33065",
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "13px",
          fontFamily: "Lato",
          fontWeight: 400,
          color: "#57697B",
        },
        hideOverlappingLabels: true,
      },
      axisBorder: {
        show: true,
        color: "#E33065",
      },
      title: {
        text: "AED",
        rotate: 360,
        offsetY: -162,
        offsetX: 45,
      },
    },
  },
};
export { analyticsChart };
